module.exports = __webpack_public_path__ + "img/logo.af63e7e1.svg";